<template>
  <div>
    <v-data-table
      :headers="headersInternal"
      :items="itemsProps"
      class="my-3 border-2 cursor-pointe"
      :items-per-page="50"
      hide-default-footer
      @click:row="rowClick"
      :no-data-text="$t('noinfo')"
      :no-results-text="$t('no_matching_records_found')"
    >
      <template v-slot:item.date="{ item }">
        <div class="text-start">{{ $moment(item.date).format("DD/MM/YYYY") }}</div>
      </template>
      <template v-slot:item.dueDate="{ item }">
        <div class="text-start">{{ $moment(item.dueDate).format("DD/MM/YYYY") }}</div>
      </template>

      <template v-slot:item.status="{ item }">
        <div class="text-start">
          <v-chip
            class="red--text"
            color="rgb(248,218,218)"
            v-if="item.status == $t('payment.pending')"
            >{{ item.status }}
          </v-chip>
          <v-chip
            class="grey--text"
            color="rgb(240,242,246)"
            v-if="item.status == $t('payment.wait_approval')"
          >{{ item.status }}</v-chip>
          <v-chip
            class="green--text"
            color="rgb(209,242,225)"
            v-if="item.status == $t('payment.paid')"
          >{{ item.status }}</v-chip>
          <v-chip
            class="orange--text"
            color="rgb(241,151,50,0.2)"
            v-if="item.status == $t('bill.edit_bill')"
          >{{ item.status }}</v-chip>
          <v-chip
            class="grey--text"
            color="rgb(240,242,246)"
            v-if="item.status == $t('bill.cancel')"
          >{{ item.status }}</v-chip>
          <v-chip
            class="white--text"
            color="rgb(63, 63, 70)"
            v-if="item.status == $t('bill.bad_debt')"
          >{{ item.status }}</v-chip>
        </div>
      </template>
      <template v-slot:item.totalValue="{ item }">
        <div class="text-end">{{ item.totalValue | currencyPrefixSign(item.currencyCode) }}</div>
      </template>
      <template v-slot:item.totalUnpaidValue="{ item }">
        <div class="text-end">{{ item.totalUnpaidValue | currencyPrefixSign(item.currencyCode) }}</div> 
      </template>
    </v-data-table>
    <!-- <invoice-dialog-component
      v-model="isInvoiceDialog"
      :invoiceId="invoiceId"
      :projectId="projectId"
      :contractData="getContract"
      @onSaveSuccess="reloadContract"
    /> -->
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import InvoiceDialogComponent from "./InvoiceDialog.component.vue";
export default {
  components: { InvoiceDialogComponent },
  computed: {
    ...mapGetters({
      getContract: "contract/getContract",
      projectId: "markets/getProjectId",
    }),
  },
  methods: {
    rowClick(invoice) {
      this.$emit("onRowClick", invoice);
    },
    reloadContract() {
      this.$emit("onLoad");
    },
  },
  data() {
    return {
      isInvoiceDialog: false,
      invoiceId: "",
      dataTable: {},
      headersInternal: []
    };
  },
  props: {
    itemsProps: Array,
    headers: {
      type: Array,
      default: () => [],
    },
  },
  created() {
    this.headersInternal = this.headers.length
      ? this.headers
      : [
        { value: "date", text: this.$t('date'), align: "center" },
        {
          text: this.$t('invoice.installment_due_date'),
          value: "dueDate",
          align: "center",
        },
        {
          text: this.$t('type'),
          value: "documentTypeString",
          align: "center",
        },
        { value: "documentId", text: this.$t('number'), align: "center" },
        { value: "customerData.name", text: this.$t('customer.title'), align: "center" },
        { value: "totalValue", text: this.$t('market.total_value'), align: "center" },
        { value: "totalUnpaidValue", text: this.$t('invoice.remaining_amount'), align: "center" },
        { value: "status", text: this.$t('status'), align: "center" },
      ]
  },
};
</script>

<style>
</style>